var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Fill",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,14h0a6,6,0,0,0-3.47,1.12,6.2,6.2,0,0,0-1.4,1.4A6,6,0,0,0,14,20h0V80h0a6,6,0,0,0,1.12,3.48,6.2,6.2,0,0,0,1.4,1.4A6,6,0,0,0,20,86H80a5.94,5.94,0,0,0,3.47-1.12A6,6,0,0,0,86,80V14ZM50.48,28a9.14,9.14,0,1,1-9.14,9.14A9.14,9.14,0,0,1,50.48,28ZM69,68.15H32a4,4,0,0,1-3.18-6.36c3.85-5,12.12-8.51,21.69-8.51s17.84,3.48,21.69,8.51A4,4,0,0,1,69,68.15Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.a7a7358697ecfc8889cca54ea27eea51.svg";
export { ForwardRef as ReactComponent };